//This script is to prevent the user from adding sample items to a cart with decorated items and vice versa.
var cart_contains = 'nothing';
$(document).ready(function(){

  cart.items.forEach(function(item){
    if((typeof item.properties['_Decoration type'] != "undefined" && item.properties['_Decoration type'].toLowerCase() == 'sample') || (typeof item.properties['Decoration type'] != "undefined" && item.properties['Decoration type'].toLowerCase() == 'sample')){
      cart_contains = 'sample'; // The last item with decoration type variable is sample
    }else{
      cart_contains = 'decorated'; // The last item with decoration type variable is NOT sample
    }
  });

  if(cart_contains == "sample"){
    //disabled all NON sample decoration type radio buttons
    $('input[name="properties[_Decoration type]"][value!="Sample"]').prop('disabled',true).parents('.shappify_radio_option').addClass('radioDisabled');
    setTimeout(function(){ // because another script is pre-selecting the first option by default
        //deselecting decorated if cart has samples
        $('input[name="properties[_Decoration type]"][value!="Sample"]').prop('checked',false).change().parents('.shappify_radio_option').removeClass('radioClicked');
      //pre-selecting sample if cart has samples
      $('input[name="properties[_Decoration type]"][value="Sample"]').prop('checked',true).change().parents('.shappify_radio_option').addClass('radioClicked');
    },500);
    
    if($('input[name="properties[_Decoration type]"][value!="Sample"]').length){ // show message only if there's a non sample option available
      $('.accord-sr-1').append('<div class="mixedCartWarning">Decorated products and samples cannot ship within the same order. Please <a onclick="return clearCart()" href="/cart/clear">clear the samples</a> from your cart.</div>');
    }
    
  }else if(cart_contains == 'decorated'){
    //disabled all sample decoration type radio buttons
    $('input[name="properties[_Decoration type]"][value="Sample"]').prop('disabled',true).parents('.shappify_radio_option').addClass('radioDisabled');
    if($('input[name="properties[_Decoration type]"][value="Sample"]').length){ // show message only if there's a sample option available
      $('.accord-sr-1').append('<div class="mixedCartWarning">Decorated products and samples cannot ship within the same order. Please place your decorated order first.</div>');
    }
    
  }
});

function clearCart(){
  // function to clear cart using ajax and then allow all decoration types
  $('#loadingContainer').show();
  $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        $('input[name="properties[_Decoration type]"]').prop('disabled',false).parents('.shappify_radio_option').removeClass('radioDisabled'); // allow all decoration types
        $('input[name="properties[_Decoration type]"]').first().prop('checked',true).change().parents('.shappify_radio_option').addClass('radioClicked'); // pre-select first decoration type
        $('.mixedCartWarning').remove(); //remove mixed cart warning
        $('#loadingContainer').hide(); 
        cart_contains = 'nothing'; // revert cart contains variable to default (in case its used anywhere else)
      },
      dataType: 'json'
  });
  return false;
}